import React from 'react'
import AppContainer from '../components/AppContainer'
import CustomAppBar from '../components/CustomAppBar'
import RouteButton from '../components/RouteButton'
import Navbar from '../components/Navbar'
import { useNavigate, useSearchParams } from 'react-router-dom';
import TextContainer from '../components/TextContainer'

function AddGroup() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const heartId = searchParams.get('heartId');

    return (
        <AppContainer>
            <CustomAppBar/>
            <Navbar title={"Add Group"} backButton />
            <TextContainer>
                <RouteButton text={"Join Group"} onClick={() => {navigate(heartId ? `/join-group?heartId=${heartId}` : '/join-group')}} />
                <RouteButton text={"Create New Group"} onClick={() => {navigate(heartId ? `/new-group?heartId=${heartId}` : '/new-group')}} />
            </TextContainer>
        </AppContainer>
    )
}

export default AddGroup